import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {GetSummaryTableResponse} from "features/model/types/hr/getSummaryTable";
import {setSummaryTableData} from "features/model/slice/hr/summary-table/summaryTableSlice";


interface GetSummaryTableParams {
    from?: string;
    to?: string;
    page?: number;
}


export const getSummaryTable = createAsyncThunk(
    "hr/getSummaryTable",
    async ({  from, to, page }: GetSummaryTableParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<GetSummaryTableResponse>(
                `/api/pivot-table`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setSummaryTableData(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);